{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Apply",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "TODAY": "Idag",
      "YESTERDAY": "Igår",
      "LAST_7_DAYS": "Senaste 7 dagarna",
      "LAST_30_DAYS": "Senaste 30 dagarna",
      "LAST_3_MONTHS": "De senaste 3 månaderna",
      "LAST_6_MONTHS": "De senaste 6 månaderna",
      "LAST_YEAR": "Senaste året",
      "CUSTOM_RANGE": "Custom date range"
    }
  }
}
